import React, { useState } from 'react'
import clsx from 'clsx'
import Tag from '../../page-components/TagTopics/Tag'
import { TagProps } from '../../page-components/TagTopics/types'
import styles from './styles.module.scss'
import ArrowDown from './assets/arrow-down.svg'

export type TagListProps = {
  tags: TagProps[]
  rootPath: string
  title: string
}

function TagList({ tags, rootPath = '', title }: TagListProps) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen(prev => !prev)

  const tagEls = tags.map(tag => (
    <Tag label={tag.label} href={`${rootPath}${tag.href}`} key={tag.href} />
  ))

  return (
    <div className={clsx(styles.root, "RelatedTopics")}>
      <div className={clsx(styles.title)}>
        <div className="h3">{title}</div>
        <button className={styles.mobileOnly} onClick={toggleOpen}>
          <img 
            className={clsx(styles.accordionIcon, { [styles.rotated]: isOpen })} 
            src={ArrowDown} 
            alt="Toggle tags" 
          />
        </button>
      </div>
      <div className={clsx(styles.tags, { [styles.hidden]: !isOpen })}>
        {tagEls}
      </div>
    </div>
  )
}

export default TagList
